export const VISUAL_SHOWCASE = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.VisualShowcaseWidgetElement';
